import tbank from "../../../assets/icons/tbank.png";
import vtb from "../../../assets/icons/vtb.png";
import sovcombank from "../../../assets/icons/sovcombank.png";

export const NOTIFICATIONS = [
  {
    id: "n1",
    source: "banks",
    bank: { name: "Т-Банк", logo: tbank },
    title: "Платёж успешно зачислен",
    preview:
      "Ваш ежемесячный платёж по кредиту успешно зачислен.\nСледующая дата списания — 17 июня.",
    body: "Ваш ежемесячный платёж успешно зачислен по договору №1224-5647021 от 22 мая 2024 г.\nСледующая дата списания — 17 июня. это все текст рыба - уведомление направляет банк или автоматические уведомления от платформы (при получении факта списания, заявки и прочей истории)",
    date: "17 мая 2026",
    time: "14:32",
    unread: true,
  },
  {
    id: "n2",
    source: "banks",
    bank: { name: "ВТБ", logo: vtb },
    title: "Предварительно одобрен кредит",
    preview:
      "Банк предварительно одобрил заявку на сумму до 1 200 000 ₽.\nОзнакомьтесь с условиями и подтвердите оформление.",
    body: "Банк предварительно одобрил заявку на сумму до 1 200 000 ₽. Ознакомьтесь с условиями и подтвердите оформление в личном кабинете банка.",
    date: "16 мая 2026",
    time: "11:08",
    unread: true,
  },
  {
    id: "n3",
    source: "banks",
    bank: { name: "Совкомбанк", logo: sovcombank },
    title: "Напоминание о платеже",
    preview:
      "До даты ежемесячного платежа осталось 2 дня.\nРекомендуем пополнить счёт заранее, чтобы избежать просрочки.",
    body: "До даты ежемесячного платежа осталось 2 дня. Рекомендуем пополнить счёт заранее, чтобы избежать просрочки.",
    date: "15 мая 2026",
    time: "09:14",
    unread: false,
  },
  {
    id: "n4",
    source: "banks",
    bank: { name: "Совкомбанк", logo: sovcombank },
    title: "Заявление на досрочное погашение принято",
    preview:
      "Банк принял заявление на частичное досрочное погашение кредита.\nПересчёт графика платежей будет выполнен после списания средств.",
    body: "Банк принял заявление на частичное досрочное погашение кредита. Пересчёт графика платежей будет выполнен после списания средств.",
    date: "14 мая 2026",
    time: "18:47",
    unread: false,
  },
  {
    id: "n5",
    source: "banks",
    bank: { name: "Т-Банк", logo: tbank },
    title: "Платёж успешно зачислен",
    preview:
      "Ваш ежемесячный платёж по кредиту успешно зачислен.\nСледующая дата списания — 17 июня.",
    body: "Ваш ежемесячный платёж по кредиту успешно зачислен. Следующая дата списания — 17 июня.",
    date: "17 апреля 2026",
    time: "12:32",
    unread: false,
  },
  {
    id: "n6",
    source: "banks",
    bank: { name: "Т-Банк", logo: tbank },
    title: "Заявление на досрочное погашение принято",
    preview:
      "Банк принял заявление на частичное досрочное погашение кредита.\nПересчёт графика платежей будет выполнен после списания средств.",
    body: "Банк принял заявление на частичное досрочное погашение кредита. Пересчёт графика платежей будет выполнен после списания средств.",
    date: "13 апреля 2026",
    time: "15:21",
    unread: false,
  },
];

export const findNotificationById = (id) =>
  NOTIFICATIONS.find((n) => n.id === id) ?? null;

export const getUnreadCount = (source = null) =>
  NOTIFICATIONS.filter(
    (n) => n.unread && (source === null || n.source === source)
  ).length;
